import React, { FC } from 'react';
import { TimePicker } from '@material-ui/pickers';
import i18n from '../../../i18n';

export interface TextControlProps {
    value: any;
    onChange: any;
    // Optional:
    isDisabled?: boolean;
}

export const TimePickerControl: FC<TextControlProps> = props => {
    const { t } = i18n.useTranslation();
    const { value, onChange, isDisabled } = props;
    return (
        <TimePicker
            value={value}
            ampm={false}
            onChange={onChange}
            inputVariant="standard"
            okLabel={t('common:timePicker:okButton')}
            cancelLabel={t('common:timePicker:cancelButton')}
            InputProps={{ disableUnderline: true }}
            disabled={isDisabled}
        />
    );
};
